import React from 'react';
import Modal from 'react-modal';
import { InjectedRouter } from 'react-router';
import Button from 'components/ButtonDeprecated';
import CoachingConstants from 'coaching/CoachingConstants';
import CoachingHeading from 'coaching/components/CoachingHeading';
import { Props as SuccessViewProps } from 'coaching/components/CoachingSelfServeView/CoachingSelfServeSuccessView';
import CoachingSelfServeAddChildAccountModal from 'coaching/components/CoachingSelfServeView/CoachingSelfServeAddChildAccountModal';
import CoachingSelfServeReservationDetails from 'coaching/components/CoachingSelfServeView/CoachingSelfServeReservationDetails';
import Copy from 'components/Copy';
import Display from 'components/Display';
import Divider from 'components/Divider';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';
import Link from 'components/Link';
import List from 'components/List';
import ListItem from 'components/ListItem';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import { withRouter } from 'app/context/Router';

import Illustration from 'assets/images/coaching/postpurchase_illustration.svg';

function CoachingSelfServePostPurchaseView(
  props: SuccessViewProps & {
    router: InjectedRouter;
  }
) {
  const eventKeyPrefix = 'coaching.self_schedule_purchase.success';
  React.useEffect(() => {
    EventTracking.trackKey(`${eventKeyPrefix}.view`);
  }, []);

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const { reservation, userTimezone, childName, selectedSubject, hasOptOutExperiment } = props;

  return (
    <React.Fragment>
      <Modal isOpen={modalIsOpen}>
        <CoachingSelfServeAddChildAccountModal
          onRequestHide={() => setModalIsOpen(false)}
          onAddChild={() => {
            // use window.location to force GTM out of browser memory
            window.location.href = CoachingConstants.COACHING_HOME_ROUTE;
          }}
          participantUUID={props.participantUUID}
          userEmail={props.userEmail}
          eventKeyScreen="self_schedule_purchase"
        />
      </Modal>
      <Row size="small">
        <Text size="small">
          {hasOptOutExperiment ? 'Your first session is set!' : 'The date and time are set!'}
        </Text>
      </Row>
      <div>
        {reservation && childName && (
          <CoachingSelfServeReservationDetails
            reservation={reservation}
            childName={childName}
            userTimezone={userTimezone}
            selectedSubject={selectedSubject}
            hasOptOutExperiment={hasOptOutExperiment}
          />
        )}
      </div>
      <Divider size="large" />
      <CoachingHeading>
        {hasOptOutExperiment ? 'Next: Add your child' : 'Next: Add your child to the session'}
      </CoachingHeading>
      <Row size="small">
        <Copy size="medium">
          Once they log in, they can share homework and join the session from their own account.
          You’ll still stay in the loop with notifications.
        </Copy>
      </Row>
      <Row size="medium">
        <MediaObject figure="right" center>
          <Text color="graphite" size="medium">
            <Row size="xsmall">
              <Text size="xsmall" weight="semibold">
                Recommended for:
              </Text>
            </Row>
            <List size="small">
              <ListItem>Students in middle or high school</ListItem>
              <ListItem>Students with online assignments</ListItem>
            </List>
          </Text>
          <Display hide="480">
            <Image src={Illustration} width={200} />
          </Display>
        </MediaObject>
      </Row>
      <MediaObject center>
        <Button
          color="koolaid"
          level="primary"
          size="medium"
          onClick={() => setModalIsOpen(true)}
          eventKey={`${eventKeyPrefix}.add_student_account.click`}>
          Add account
        </Button>
        <Link
          color="ink"
          underline
          weight="semibold"
          href={CoachingConstants.COACHING_HOME_ROUTE} // hard reload to unload GTM
          eventKey={`${eventKeyPrefix}.skip.click`}>
          <Text size="small">Not now, continue with my account</Text>
        </Link>
      </MediaObject>
    </React.Fragment>
  );
}

export default withRouter(CoachingSelfServePostPurchaseView);
